module.exports = __webpack_public_path__ + "img/partner-list-7.18adfe46.png";